<template lang="html">
  <header class="header-auth">
    <div class="container">
      <div class="row">
        <div class="header-auth__logo-wrapper col-12 col-md-6 col-xl-5">
          <a href="/">
            <picture class="header-auth__logo">
              <img src="~@/assets/img/header/logo.svg"
                   srcset="~@/assets/img/header/logo.svg"
                   alt="Унистрой Маркет">
            </picture>
          </a>
          <DateTime />
        </div>

        <nav class="header-auth__nav-wrapper col-12 col-md-6 col-xl-7">
          <!-- div class="header-auth__nav-item">
            <form class="header-auth__search" :class="{'header-auth__search--open': isSearchable}" action="https://echo.htmlacademy.ru" method="post">
              <input
                type="search"
                placeholder="Ключевое слово для поиска"
                class="header-auth__search-input"
                value=""
                id="header-auth__search-input"
                name="search-header"
                required
              />
              <span class="header-auth__search-icon" @click="isSearchable = !isSearchable"></span>
            </form>
          </div>
          <div class="header-auth__nav-item">
            <a href="#" class="header-auth__nav-link header-auth__nav-link--message"></a>
          </div>
          <div class="header-auth__nav-item">
            <a href="#" class="header-auth__nav-link header-auth__nav-link--call"></a>
          </div>
          <div class="header-auth__nav-item">
            <a href="#" class="header-auth__nav-link header-auth__nav-link--info"></a>
          </div-->
          <div class="header-auth__nav-item">
            <router-link :to="{ name: 'Auth'}"
                         class="header-auth__nav-link header-auth__nav-link--profile-auth"/>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script lang="js">
import { defineComponent } from 'vue';
import DateTime from '@/components/elements/DateTime.vue';

export default defineComponent({
  name: 'AuthHeader',
  components: {
    DateTime,
  },
  data() {
    return {
      isSearchable: false,
    };
  },
});
</script>

<style lang="scss">
  @import "~@/assets/css/_header-auth.scss";
</style>
